import React from "react";
import statusStyles from "../index.module.scss";
import styles from "./index.module.scss";
export default class InProgress extends React.Component {
    render() {
        return (React.createElement("div", { className: `${statusStyles.baseStatus} ${styles.status}` }, "In progress"));
    }
}
